import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import ColoredButton from "../component/ColoredButton";
import OrderService from "../services/Order";
import { useSelector } from "react-redux";
import ThemeTable from "../component/ThemeTable";
import OtherService from "../services/Other";

const AddressApprovalBulk = () => {
  const userData = useSelector((state) => state.userTypeSlice.userData);

  const location = useLocation();
  const addressData = location.state?.addressData || {};
  const navigate = useNavigate();

  const [downloadLink, setDownloadLink] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const [failedAdd, setFailedAdd] = useState([])

  useEffect(() => {
    OtherService.addressFailedUpload().then(res => {
      console.log("TEST====>", JSON.stringify(res))
      if(res.status) {
        setFailedAdd(res.data.data);
      }
    })
  }, [])

  useEffect(() => {
    const hierId = userData?.hierarchies_id;

    if (!hierId) return;

    OrderService.addressExcell(hierId)
      .then((res) => {
        if (res.status) {
          setDownloadLink(res.data.url);
        }
      })
      .catch(() => {
        toast.error("Error while fetching document");
      });
  }, [userData]);

  const handleDownload = () => {
    if (!downloadLink) return;

    window.open(downloadLink, "_blank");
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    setSelectedFile(file);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error("Please select an Excel file first");
      return;
    }

    try {
      setUploading(true);

      const formData = new FormData();
      formData.append("file", selectedFile);
      // formData.append("hierarchies_id", userData?.hierarchies_id);

      const res = await OrderService.uploadAddressExcel(formData);

      if (res?.status) {
        toast.success("File uploaded successfully");
        setSelectedFile(null);
      } else {
        toast.error(res?.message || "Upload failed");
      }
    } catch (error) {
      console.log(error);
      toast.error("Error uploading file");
    } finally {
      setUploading(false);
    }
  };

  // const failedUploadColumns = [
  //   {
  //     Header: "Date",
  //     accessor: "created_at",
  //     Cell: ({ value }) =>
  //       value
  //         ? new Date(value).toLocaleString("en-IN", {
  //             day: "2-digit",
  //             month: "short",
  //             year: "numeric",
  //             hour: "2-digit",
  //             minute: "2-digit",
  //           })
  //         : "-",
  //   },
  //   {
  //     Header: "Download Error File",
  //     accessor: "file_path",
  //     Cell: ({ value }) => (
  //       <a
  //         href={value}
  //         target="_blank"
  //         rel="noopener noreferrer"
  //         className="btn btn-sm btn-primary"
  //       >
  //         Download
  //       </a>
  //     ),
  //   },
  // ];

  return (
    <>
      <BreadCrumbSecttion
        pageTitle="Address Approval Bulk"
        currentPageName="Address Approval Bulk"
      />

      <section className="padTop50">
        <Container>
          <Row className="justify-content-center align-item-center h-100">
            <Col xs={12}>
              <div className="userInfoBox">
                <div
                  className="d-flex justify-content-between align-items-center flex-wrap gap-4 p-4"
                  style={{
                    background: "#fff",
                    borderRadius: "16px",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                    border: "1px solid #eef0f4",
                  }}
                >
                  {/* Download */}
                  <div className="d-flex flex-column">
                    <h6 className="mb-2 fw-bold">Download Template</h6>

                    <span
                      className="text-muted mb-3"
                      style={{ fontSize: "14px" }}
                    >
                      Download the Excel template, update address details,
                      and upload it back.
                    </span>

                    <PrimaryGradientButton
                      disabled={!downloadLink}
                      buttonText="⬇ Download Excel Template"
                      onClick={handleDownload}
                    />
                  </div>

                  {/* Upload */}
                  <div
                    className="d-flex align-items-center gap-3 p-3 flex-wrap"
                    style={{
                      background: "#f8f9fc",
                      borderRadius: "12px",
                      border: "1px dashed #d6dbe5",
                    }}
                  >
                    <input
                      type="file"
                      accept=".xlsx,.xls"
                      className="form-control"
                      onChange={handleFileChange}
                      style={{
                        minWidth: "260px",
                        borderRadius: "10px",
                        padding: "10px",
                      }}
                    />

                    <ColoredButton
                      buttonText={
                        uploading ? "Uploading..." : "⬆ Upload File"
                      }
                      disabled={uploading}
                      onClick={handleUpload}
                    />
                  </div>
                </div>

                {selectedFile && (
                  <div className="mt-3 text-muted">
                    Selected file: <strong>{selectedFile.name}</strong>
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
  <Col xs={12}>
    <div className="table-responsive">
      <table className="table table-bordered table-hover">
        <thead>
          <tr>
            <th>Date</th>
            <th>Download Error File</th>
          </tr>
        </thead>
        <tbody>
          {failedAdd?.length > 0 ? (
            failedAdd.map((item) => (
              <tr key={item.id}>
                <td>
                  {new Date(item.created_at).toLocaleString()}
                </td>
                <td>
                  <a
                    href={item.file_path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-primary"
                  >
                    Download
                  </a>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="2" className="text-center">
                No failed uploads found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </Col>
</Row>
        </Container>
      </section>
    </>
  );
};

export default AddressApprovalBulk;